import { Languages } from '../types';

export const LANGUAGES_OPTIONS = [Languages.PT_BR, Languages.EN_US];
